import { registerComponent } from 'lib/react_on_rails';

import TooltipWithLink from './tooltip_with_link';

registerComponent('TooltipWithLink', TooltipWithLink);

export default TooltipWithLink;
